import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsComponent } from './charts.component';
import { BaseChartDirective } from 'ng2-charts';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ChartsComponent,
  ],
  imports: [
    CommonModule,
    BaseChartDirective,
    TranslateModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    ChartsComponent,
  ]
})
export class ChartsModule { }
